const menuRoute = [
	{
		name: "Dasboard",
		url: "/",
	},
	{
		name: "Home",
		url: "/",
	},
	{
		name: "Category",
		url: "/category",
	},
	{
		name: "Games",
		url: "/game",
	},
];
export default menuRoute
